import type { ThemeComponentType } from '../types';

export const Text: ThemeComponentType = {
  defaultProps: {
    component: 'p',
    size: 'lg',
    weight: 500,
  },
};
